var _excluded = ["title", "onCloseButtonClick", "content", "width", "buttons", "isOpen", "isLoading"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useState } from "react";
import { StyledPreventPageScroll } from "../../../helpers/PreventPageScroll";
import useBreakpoint from "../../../hooks/useBreakpoint";
import useModalFocus from "../../../hooks/useModalFocus";
import { animationDuration } from "../../../settings";
import ButtonAtm from "../../atoms/ButtonAtm";
import WrapOrg from "../../organisms/WrapOrg";
import ModalHeaderMol from "./ModalHeaderMol";
import ModalOrg from "./ModalOrg";
import { breakpointValue } from "./ModalTemplate.settings";
function ModalTemplate(_ref) {
  var title = _ref.title,
    onCloseButtonClick = _ref.onCloseButtonClick,
    content = _ref.content,
    width = _ref.width,
    buttons = _ref.buttons,
    isOpen = _ref.isOpen,
    isLoading = _ref.isLoading,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isBiggerScreen = useBreakpoint(breakpointValue);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasAnimationOnClose = _useState2[0],
    setHasAnimationOnClose = _useState2[1];
  var _useModalFocus = useModalFocus(),
    handleFocusOnModalClose = _useModalFocus.handleFocusOnModalClose;
  var handleCloseButtonClick = useCallback(function (event) {
    setHasAnimationOnClose(true);
    if (onCloseButtonClick) {
      setTimeout(function () {
        onCloseButtonClick(event);
        setHasAnimationOnClose(false);
      }, animationDuration["default"]);
    }
    handleFocusOnModalClose();
  }, [onCloseButtonClick]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledPreventPageScroll, null), /*#__PURE__*/React.createElement(ModalOrg, _extends({}, restProps, {
    header: /*#__PURE__*/React.createElement(ModalHeaderMol, {
      title: title,
      onCloseButtonClick: onCloseButtonClick,
      handleCloseButtonClick: handleCloseButtonClick,
      isLoading: isLoading
    }),
    headerHasNoTitle: !title,
    content: content,
    width: width,
    buttons: buttons ? /*#__PURE__*/React.createElement(WrapOrg, {
      gutterSpace: isBiggerScreen ? 1 : 2
    }, buttons.map(function (button) {
      return /*#__PURE__*/React.createElement(ButtonAtm, {
        color: button.color,
        variant: button.variant,
        isExpanded: !isBiggerScreen,
        to: button.to,
        href: button.href,
        openInNewTab: button.openInNewTab,
        title: button.title,
        onClick: button.onClick,
        key: button.title
      }, button.text);
    })) : null,
    isOpen: isOpen,
    isLoading: isLoading,
    hasAnimationOnClose: hasAnimationOnClose,
    handleCloseButtonClick: handleCloseButtonClick
  }))) : null);
}
export default ModalTemplate;